import { render, staticRenderFns } from "./compatibility-icons.vue?vue&type=template&id=69a21197&"
import script from "./compatibility-icons.vue?vue&type=script&lang=js&"
export * from "./compatibility-icons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports